import '../landing/styles/landing.css';
import '../landing/styles/overrides.css';
import LandingLayout from './layout/LandingLayout';
import Demo6Hero from './components/demo6/Demo6Hero';
import Features from './components/Features';
import Demo6Content3 from './components/demo6/Demo6Content3';
import Demo6Content10 from './components/demo6/Demo6Content10';
import Demo6Features4 from './components/demo6/Demo6Features4';
import Demo6Statistic1 from './components/demo6/Demo6Statistic1';
import Demo6Content6 from './components/demo6/Demo6Content6';
import Demo6Statistic2 from './components/demo6/Demo6Statistic2';
import Demo6Content2 from './components/demo6/Demo6Content2';
import Demo6Content7 from './components/demo6/Demo6Content7';
import Faq from './components/Faq';
import Demo6Price from './components/demo6/Demo6Price';
import Demo6CTA11 from './components/demo6/Demo6CTA11';

const LandingPage = ({ isAuthenticated, onLogin, onLogout, onRegister, onDashboard }) => {
    return (
        <LandingLayout
            isAuthenticated={isAuthenticated}
            onLogin={onLogin}
            onLogout={onLogout}
            onRegister={onRegister}
            onDashboard={onDashboard}
        >
            <Demo6Hero isAuthenticated={isAuthenticated} onRegister={onRegister} onDashboard={onDashboard} />
            <Features />
            <Demo6Content3 />
            <Demo6Content10 />
            <Demo6Features4 />
            <Demo6Statistic1 />
            <Demo6Content6 />
            <hr className="divider" />
            <Demo6Statistic2 />
            <hr className="divider" />
            <Demo6Content2 />
            <hr className="divider" />
            <Demo6Content7 />
            <Faq />
            <Demo6Price isAuthenticated={isAuthenticated} onRegister={onRegister} onDashboard={onDashboard} />
            <Demo6CTA11 isAuthenticated={isAuthenticated} onRegister={onRegister} onDashboard={onDashboard} />
        </LandingLayout>
    );
};

export default LandingPage;
